import styled from 'styled-components';
import {
  Container as UnstyledContainer,
  Row as UnstyledRow,
  Col as UnstyledCol,
} from 'react-bootstrap';
import propTypes from 'prop-types';

const StyledGridContainer = styled.div`
  border: ${(props) => (props.pageBorder ? '1px solid black' : 'unset')};
  overflow-x: ${(props) => (props.verticalScroll ? 'scroll' : 'hidden')};
  overflow-y: ${(props) => (props.horizontalScroll ? 'scroll' : 'hidden')};
  height: ${(props) => props.pageHeight || '100vh'};
  min-width: 1200px;
`;

export const Container = styled(UnstyledContainer)`
  padding-right: 0px;
  padding-left: 0px;
  margin-right: 0px;
  margin-left: 0px;
  max-width: 100%;
`;

export const Row = styled(UnstyledRow)`
  margin-right: 0px;
  margin-left: 0px;
`;

export const Col = styled(UnstyledCol)`
  padding-right: 0px;
  padding-left: 0px;
  margin-right: 0px;
  margin-left: 0px;
`;

const GridContainer = ({ children, pageHeight, pageBorder, horizontalScroll, verticalScroll }) => (
  <StyledGridContainer
    pageHeight={pageHeight}
    horizontalScroll={horizontalScroll}
    verticalScroll={verticalScroll}
    pageBorder={pageBorder}
  >
    {children}
  </StyledGridContainer>
);

GridContainer.propTypes = {
  children: propTypes.node.isRequired,
  pageHeight: propTypes.string,
  horizontalScroll: propTypes.bool,
  verticalScroll: propTypes.bool,
  pageBorder: propTypes.bool,
};

GridContainer.defaultProps = {
  pageHeight: '',
  horizontalScroll: false,
  verticalScroll: false,
  pageBorder: false,
};
export default GridContainer;
